import { SortBarItemProps, useTranslations } from "@bsm/component";
import { useMemo } from "react";

export const useScholarityListSort = () => {
    const [DATE] = useTranslations(i18n);
    return useMemo(
        () => [{ label: DATE, value: "updatedAt", className: 'ml-auto' }],
        []
    ) as Array<SortBarItemProps>;
};

const i18n = ["std_date"];
 